/* @flow */
import cx from 'classnames';
import Link from 'components/Link.jsx';
import React from 'react';

import './styles/FooterNavItem.scss';

class FooterNavItem extends React.Component {
  static propTypes = {
    divided: React.PropTypes.bool,
  };

  static defaultProps = {
    divided: false,
  };

  render() {
    return (
      <Link
        {...this.props}
        target="_blank"
        weight="semibold"
        className={cx('FooterNavItem', {
          'FooterNavItem--divided': this.props.divided,
        })}>
        {this.props.children}
      </Link>
    );
  }
}

export default FooterNavItem;



// WEBPACK FOOTER //
// ./src/components/FooterNavItem.jsx